import React, { useEffect, useState } from "react";

//COMPONENTS
import GalleryViewer from "./galleryViewer";
import PhotoAlbumViewer from "./photoAlbumViewer";
import VideoAlbumViewer from "./videoAlbumViewer";

function PodHandler() {
    const [view, setView] = useState("gallery");
    const [albumName, setAlbumName] = useState("");

    function goToAlbum(name, type) {
        setAlbumName(name);
        setView(type);
    }

    function goBack() {
        setView("gallery");
    }

    return (
        <div>
            {view == "gallery" && <GalleryViewer goToAlbum={goToAlbum} />}
            {view == "palbum" && <PhotoAlbumViewer name={albumName} goBack={goBack} />}
            {view == "valbum" && <VideoAlbumViewer name={albumName} goBack={goBack} />}
        </div>
    );
}

export default PodHandler;
